<template>
  <div class="group">
    <div>
      <span class="group-title">名称：&nbsp;&nbsp;</span>
      <span>{{ item.name }}</span>
    </div>
    <br />
    <div class="subset">
      <span class="group-title">下级：&nbsp;&nbsp;</span>
      <table class="subset-table">
        <thead>
          <tr>
            <td>序号</td>
            <td>id</td>
            <td>名称</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in item.children" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ item.id }}</td>
            <td>{{ item.name }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { flattenTree } from "@/utils/utils";
export default {
  data() {
    return {
      item: [],
      flattenGroupTree: []
    };
  },
  computed: {
    ...mapState(["groupTree"])
  },
  watch: {
    $route() {
      this.getItem();
    }
  },
  mounted() {
    this.flattenGroupTree = flattenTree(this.groupTree);
    this.getItem();
  },
  methods: {
    getItem() {
      this.item =
        this.flattenGroupTree.find(x => x.id == this.$route.params.id) || {};
    }
  }
};
</script>

<style lang="less" scoped>
.group {
  padding: 20px 30px;
  font-size: 18px;
  color: #606266;
}
.group-title {
  font-weight: bold;
}
.subset {
  display: flex;
}
.subset-table {
  width: 360px;
  border: 1px solid #eaeef1;
}
.subset-table > thead > tr > th,
.subset-table > tbody > tr > th,
.subset-table > thead > tr > td,
.subset-table > tbody > tr > td {
  border: 1px solid #eaeef1;
}
.subset-table > thead > tr {
  background-color: #f8f8f8;
}
.subset-table > tbody > tr:nth-of-type(even) {
  background-color: #f8f8f8;
}
</style>
